import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AppComponent } from '../app.component';
import { DataserviceService } from '../dataservice.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-companies',
  templateUrl: './companies.component.html',
  styleUrls: ['./companies.component.css'],
})
export class CompaniesComponent {
  companies: any[] = [];
  companiesList: any[] = [];
  isModalVisible: boolean = false;
  companyForm: FormGroup;
  loading: boolean = false;
  distributors: any;
  providers: any;
  providersLoading: boolean = false;
  companyProviders: any[] = [];
  currentUser: any;

  constructor(
    private app: AppComponent,
    private data: DataserviceService,
    private nzNotify: NzNotificationService
  ) {

    this.companyForm = new FormGroup({
      id: new FormControl(null),
      name: new FormControl(null, [Validators.required]),
      phone: new FormControl('', [Validators.required]),
      distributor_id: new FormControl(null, [Validators.required]),
      providers: new FormControl(null),
      status: new FormControl('active'),
      leaderboard_preference: new FormControl(null)
    });

  }

  ngOnInit() {
    this.loading = true;
    this.currentUser = JSON.parse(localStorage.getItem('user')!);
    this.getDistributors();

    if(this.currentUser?.super_admin) {
      this.getCompanies();
    }else if(this.hasPermissions('view_distributor_companies')) {
      this.getDistributorCompanies()
    }else {
     this.companies = [] 
    }

  }

  getDistributorCompanies() {
    this.data.getData(`company/companies-by-distributor/${this.currentUser?.distributor_id}`)
      .subscribe({
        next: (res: any) => {
          this.companies = res.data
          this.companiesList = res.data
          this.companyForm.get('distributor_id')?.setValue(this.currentUser?.distributor_id);
          this.getDistributorsProviders( this.companyForm.get('distributor_id')?.value, false);
          this.loading = false;
        },
        error: (err: any) => {
          this.errorNotification('Failed to load companies!')
          this.loading = false;
        }
      })
  }

  getCompanies() {
    this.data.getData(`company`)
      .subscribe({
        next: (res: any) => {
          this.companies = res.data
          this.companiesList = res.data
          this.loading = false;
        },
        error: (err: any) => {
          this.errorNotification('Failed to load companies!')
          this.loading = false;
        }
      })
  }

  getDistributors() {
    this.data.getData('distributors')
      .subscribe({
        next: (res: any) => {
          this.distributors = res?.data
        },
        error: (err: any) => {
          this.errorNotification('Failed to load distributors!')
        }
      })
  }

  hasPermissions(permission: string): boolean {
    return this.app.hasPermission(permission)
  }

  search(event: any) {
    this.companiesList = this.companies.filter((item: any) => {

      const name = item.name.toLowerCase();
      const phone = item.phone.toLowerCase();
      const distributor = item.distributor?.toLowerCase() || '';

      return (
        name.includes(event.target.value.toLowerCase()) ||
        phone.includes(event.target.value.toLowerCase()) ||
        distributor.includes(event.target.value.toLowerCase())
      );
      
    });
  }

  distributorChanged(event: any) {
    if(event && this.isModalVisible) {
      this.getDistributorsProviders(event, true);
    }
  }

  getDistributorsProviders(company: any, modal: boolean) {
    this.providersLoading = true;
    this.data.getData(`company/distributor-providers/${company || this.currentUser?.distributor_id}`)
      .subscribe({
        next: (res: any) => {
          this.providers = res?.data || [];

          if(company?.providers?.length > 0) {
            this.companyProviders = this.providers.filter((obj: any) => company.providers.includes(obj.id));

            this.companyProviders.forEach((provider) => {
              this.companyForm.addControl(provider.id, new FormControl([]));
            });
          }
          
          if(modal) {
            this.isModalVisible = true;
          }

          this.providersLoading = false;
        }, 
        error: (err: any) => {
          this.providersLoading = false;
          this.errorNotification('Failed to get company providers')
        }
      })
  }

  async showModal(company: any) {
    if(company) {
      this.companyForm.patchValue(company, { emitEvent: false });
    }else {
      this.companyForm.get('distributor_id')?.setValue(this.currentUser?.distributor_id);
    }

    await this.getDistributorsProviders(company.distributor_id, true);
  }

  addCompany() {
    this.data.postData( this.companyForm.value , `company/create`)
    .subscribe({
      next: (res: any) => {
        if(!this.currentUser?.super_admin) {
          this.getCompanies();
        }else if(this.hasPermissions('view_distributor_companies')) {
          this.getDistributorCompanies()
        }else {
         this.companies = [] 
        }
        this.successNotification('created')
        this.isModalVisible = false;
        this.companyProviders.forEach(provider => {
          if (this.companyForm.contains(provider.id)) {
            this.companyForm.removeControl(provider.id);
          }
        });
        this.companyProviders = [];
        this.companyForm.reset();
      },
      error: (err: any) => {
        this.loading = false
        this.errorNotification('Failed to create company!')
      }
    })
  }

  updateCompany() {
    this.data.postData( this.companyForm.value, `company/update`)
    .subscribe({
      next: (res: any) => {
        if(!this.currentUser?.super_admin) {
          this.getCompanies();
        }else if(this.hasPermissions('view_distributor_companies')) {
          this.getDistributorCompanies()
        }else {
         this.companies = [] 
        }
        this.successNotification('updated')
        this.isModalVisible = false;
        this.companyForm.patchValue({
          id: null,
          name: null,
          phone: null,
          providers: null,
          status: null,
        })
      },
      error: (err: any) => {
        console.log(err)
        this.loading = false
        this.errorNotification('Failed to update company!')
      }
    })
  }

  confirmAddEdit() {
    if (this.companyForm.valid) {
      this.loading = true
      if ( this.companyForm.value.id) {
        this.updateCompany()
      } else {
        this.addCompany()
      }
    }else {
      this.nzNotify.create(
        'warning',
        'Warning!',
        `Please fill out the required fields`,
        { nzPlacement: 'top' }
      );
    }
  }

  cancelAddEdit() {
    this.isModalVisible = false;
    this.companyProviders.forEach(provider => {
      if (this.companyForm.contains(provider.id)) {
        this.companyForm.removeControl(provider.id);
      }
    });
    this.companyProviders = [];
    this.companyForm.reset();
  }

  successNotification(str: string) {
    this.nzNotify.create(
      'success',
      'Success!',
      `Company was ${str} successfully!`,
      { nzPlacement: 'top' }
    );
  }

  errorNotification(str: string) {
    this.nzNotify.create(
      'error',
      'Error!',
      str,
      { nzPlacement: 'top' }
    );
  }
}
